import PropTypes from 'prop-types'
import HelpTooltip from 'components/tooltip/HelpTooltip'
import { CampaignTypes } from '../../Codes'

const DetailHasCreative = ({ actions, hierarchy, subType }) => {
  const [action] = actions
  const {
    licenseReviewNumber,
    licenseReviewDocumentId,
    recLicenseReviewNumber,
    recLicenseReviewDocumentId,
  } = action?.after || {}
  const { LICENSE_DOCUMENT_NAME, REC_LICENSE_DOCUMENT_NAME } = hierarchy
  const basics = action?.after?.summaries?.filter(
    ({ assetCategory }) => assetCategory === '기본'
  )
  const others = action?.after?.summaries?.filter(
    ({ assetCategory }) => assetCategory !== '기본'
  )
  return (
    <>
      <p className="subtit_layer">
        내용
        <HelpTooltip>일부 항목은 내용의 이력을 제공하지 않습니다.</HelpTooltip>
      </p>
      <table className="tbl_layer tbl_layer_cont">
        <caption className="hide_caption">변경이력 내용 안내 표</caption>
        <colgroup>
          <col style={{ width: 161 }} />
          <col style={{ width: 174 }} />
          <col style={{ width: 130 }} />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="col">구분</th>
            <th scope="col">소재타입</th>
            <th scope="col">항목</th>
            <th scope="col">값</th>
          </tr>
          {basics?.map((summary, index) => (
            <tr key={`key_basic_${index}`}>
              <th scope="row">{summary.assetCategory}</th>
              <td>
                <div className="inner_cell">{summary.assetType}</div>
              </td>
              <td>
                <div className="inner_cell">{summary.field}</div>
              </td>
              <td>
                <div className="inner_cell">{summary.value}</div>
              </td>
            </tr>
          ))}
          {recLicenseReviewNumber && (
            <tr>
              <th scope="row">법적 고지</th>
              <td>
                <div className="inner_cell" />
              </td>
              <td>
                <div className="inner_cell">법적 고지문구 - 추천소재</div>
              </td>
              <td>
                <div className="inner_cell">{recLicenseReviewNumber}</div>
              </td>
            </tr>
          )}
          {recLicenseReviewDocumentId && REC_LICENSE_DOCUMENT_NAME && (
            <tr>
              <th scope="row">법적 고지</th>
              <td>
                <div className="inner_cell" />
              </td>
              <td>
                <div className="inner_cell">소재심사서류 - 추천소재</div>
              </td>
              <td>
                <div className="inner_cell">{REC_LICENSE_DOCUMENT_NAME}</div>
              </td>
            </tr>
          )}
          {licenseReviewNumber && (
            <tr>
              <th scope="row">
                {subType === CampaignTypes.TALK_CHANNEL
                  ? '법적 고지'
                  : '의료광고심의대상'}
              </th>
              <td>
                <div className="inner_cell" />
              </td>
              <td>
                <div className="inner_cell">
                  {subType === CampaignTypes.TALK_CHANNEL
                    ? '법적 고지문구 - 공통 or 맞춤소재'
                    : '심의필번호'}
                </div>
              </td>
              <td>
                <div className="inner_cell">{licenseReviewNumber}</div>
              </td>
            </tr>
          )}
          {licenseReviewDocumentId && LICENSE_DOCUMENT_NAME && (
            <tr>
              <th scope="row">
                {subType === CampaignTypes.TALK_CHANNEL
                  ? '법적 고지'
                  : '의료광고심의대상'}
              </th>
              <td>
                <div className="inner_cell" />
              </td>
              <td>
                <div className="inner_cell">
                  {subType === CampaignTypes.TALK_CHANNEL
                    ? '소재심사서류 - 공통 or 맞춤소재'
                    : '소재심사서류'}
                </div>
              </td>
              <td>
                <div className="inner_cell">{LICENSE_DOCUMENT_NAME}</div>
              </td>
            </tr>
          )}
          {others?.map((summary, index) => (
            <tr key={`key_${index}`}>
              <th scope="row">{summary.assetCategory}</th>
              <td>
                <div className="inner_cell">{summary.assetType}</div>
              </td>
              <td>
                <div className="inner_cell">{summary.field}</div>
              </td>
              <td>
                <div className="inner_cell">{summary.value}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}

export default DetailHasCreative

DetailHasCreative.propTypes = {
  actions: PropTypes.array,
  hierarchy: PropTypes.object,
  subType: PropTypes.string,
}
